import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import { seo } from "../translations/seo";

const H2 = "font-outfit text-xl font-bold text-slate-800 mb-3";
const MAIL = <a href="mailto:dottbb@outlook.com" className="text-[#2E4DB5] underline">dottbb@outlook.com</a>;

export default function Privacy() {
  const { language } = useLanguage();
  return (
    <div className="min-h-screen bg-white font-jakarta">
      <Navbar />
      <Seo title={seo[language].privacy.title} description={seo[language].privacy.description} />
      <div className="pt-28 pb-24 max-w-3xl mx-auto px-6 sm:px-8">
        <h1 className="font-outfit text-4xl font-bold text-slate-900 mb-2">
          Politique de confidentialité
        </h1>
        <p className="text-slate-400 text-sm mb-10 pb-6 border-b border-slate-100" data-testid="privacy-updated">
          Dernière mise à jour : 14/10/2026
        </p>

        <div className="space-y-8 text-slate-600 text-base leading-relaxed" data-testid="privacy-content">

          <section>
            <h2 className={H2}>1. Responsable du traitement</h2>
            <p>Le responsable du traitement de vos données est Benedetta Branchesi, indépendant, n° BCE 0663580661, dont le siège est situé à Avenue de la Renaissance 21, 1000 Bruxelles. Contact : {MAIL}.</p>
          </section>

          <section>
            <h2 className={H2}>2. Données collectées</h2>
            <ul className="list-disc pl-6 space-y-2 mb-3">
              <li><strong>Via le formulaire de contact :</strong> nom, adresse e-mail, numéro de téléphone et contenu de votre message.</li>
              <li><strong>Lors de la navigation :</strong> adresse IP, type de navigateur, pages consultées et données de connexion.</li>
            </ul>
            <p>Merci de ne pas transmettre d’informations médicales détaillées via le formulaire. Elles seront abordées lors de votre consultation.</p>
          </section>

          <section>
            <h2 className={H2}>3. Finalités et bases légales</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Répondre à vos demandes et organiser un rendez-vous : mesures précontractuelles et intérêt légitime (art. 6.1.b et 6.1.f RGPD).</li>
              <li>Mesurer l’audience et améliorer le site : votre consentement (art. 6.1.a RGPD).</li>
              <li>Respecter nos obligations légales (art. 6.1.c RGPD).</li>
            </ul>
          </section>

          <section>
            <h2 className={H2}>4. Durée de conservation</h2>
            <p>Les messages du formulaire sont conservés au maximum 12 mois après le dernier échange. Si votre demande donne lieu à une prise en charge, les données relèvent du dossier patient et sont conservées selon les délais légaux applicables. Les données de mesure d’audience sont conservées au maximum 12 mois.</p>
          </section>

          <section>
            <h2 className={H2}>5. Destinataires et sous-traitants</h2>
            <p className="mb-3">Vos données ne sont pas vendues. Elles sont uniquement partagées avec :</p>
            <ul className="list-disc pl-6 space-y-2 mb-3">
              <li><strong>Emergent</strong> : hébergement du site ;</li>
              <li><strong>GigaWeb</strong> : hébergement du domaine et de la messagerie ;</li>
              <li><strong>Google Fonts</strong> : affichage des polices, ce qui implique la transmission de votre adresse IP à Google ;</li>
              <li>les autorités, lorsque la loi l’exige.</li>
            </ul>
            <p>En cas de transfert hors de l’Union européenne, celui-ci est encadré par les garanties prévues par le RGPD (décision d’adéquation ou clauses contractuelles types).</p>
          </section>

          <section>
            <h2 className={H2}>6. Sécurité</h2>
            <p>Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données contre tout accès non autorisé, perte ou divulgation.</p>
          </section>

          <section>
            <h2 className={H2}>7. Vos droits</h2>
            <p className="mb-3">Conformément au RGPD, vous disposez d’un droit d’accès, de rectification, d’effacement, de limitation, d’opposition et de portabilité de vos données. Vous pouvez aussi retirer votre consentement à tout moment. Pour exercer ces droits, écrivez-nous à {MAIL}.</p>
            <p>Vous avez également le droit d’introduire une plainte auprès de l’Autorité de protection des données, Rue de la Presse 35, 1000 Bruxelles,{" "}
              <a href="https://www.autoriteprotectiondonnees.be" target="_blank" rel="noopener noreferrer" className="text-[#2E4DB5] underline" data-testid="privacy-apd-link">www.autoriteprotectiondonnees.be</a>.
            </p>
          </section>

          <section>
            <h2 className={H2}>8. Modifications</h2>
            <p>Cette politique peut être mise à jour. La date de la dernière modification figure en haut de cette page.</p>
          </section>

        </div>

        <div className="mt-12 pt-6 border-t border-slate-100">
          <Link to="/" className="text-[#2E4DB5] font-semibold hover:opacity-70 transition-opacity">
            ← Retour à l'accueil
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
